import { httpCreate } from './http';

const http = httpCreate('/shop/api/answer-report/');

export const answerReport = {
	// 获取答案列表
	listTr(activityId, surveyId, params) {
		return http.get(`${activityId}/${surveyId}`, { params: params });
	},
	listTrGather(gatherId, surveyId, params) {
		return http.get(`${gatherId}/gather/${surveyId}`, { params: params });
	},
	batchAdopt(surveyId, ids) {
		return http.put(`/${surveyId}`, ids);
	},
	adopt(surveyId, body) {
		return http.put(`/audit/${surveyId}`, body);
	},
};
